import { render, staticRenderFns } from "./BookingPositionTechnician.vue?vue&type=template&id=68560e0c&scoped=true&"
import script from "./BookingPositionTechnician.vue?vue&type=script&lang=js&"
export * from "./BookingPositionTechnician.vue?vue&type=script&lang=js&"
import style0 from "./BookingPositionTechnician.vue?vue&type=style&index=0&id=68560e0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68560e0c",
  null
  
)

export default component.exports